import { useTranslations } from '@npco/utils-translations'
import {
  Box,
  InfoBox,
  INFOBOX_PRIORITY,
  INFOBOX_VARIANT,
} from '@npco/zeller-design-system'

import { TransferStateCondition as Condition } from 'pages/Transfer/states/TransferState/TransferStateCondition'
import { contactTransferTranslations } from 'pages/Transfer/Transfer.i18n'
import {
  TransferContactState,
  TransferGeneralState,
} from 'pages/Transfer/Transfer.stateMachine'

export const TransferContactFallbackMessage = () => {
  const t = useTranslations(contactTransferTranslations)
  return (
    <Condition
      parent={TransferGeneralState.ContactTransfer}
      allowedStates={[
        TransferContactState.DeOutFallbackSummary,
        TransferContactState.DeOutFallbackSending,
      ]}
    >
      <Box pt={{ _: '16px', XS: '40px' }}>
        <InfoBox
          priority={INFOBOX_PRIORITY.MEDIUM}
          variant={INFOBOX_VARIANT.POSITIVE}
        >
          <InfoBox.Message>{t('deFallbackMessage')}</InfoBox.Message>
        </InfoBox>
      </Box>
    </Condition>
  )
}
